import { Inbox } from '@spike/omnichannel-model';
import { ChannelStatus } from './ChannelCard/ChannelCard';

export interface TextMessagesCardContent {
    status: ChannelStatus;
    description: string;
    footnote?: string;
    muted?: boolean;
}

/** (786) 723-8329 reads like a phone number; +17867238329 reads like a database column. */
export const formatPhone = (phone: string): string => {
    const digits = phone.replace(/\D/g, '');
    const local = digits.length > 10 ? digits.slice(-10) : digits;

    return local.length === 10 ? `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}` : phone;
};

/**
 * The texting number is provisioned by Cuddles per location (`marketplaces.twilio_phone_number`) and is
 * what routes an inbound SMS back to this inbox — the business never connected a carrier account, so the
 * card states the number instead of offering an action it cannot take.
 */
export const textMessagesCardContent = (inbox?: Inbox): TextMessagesCardContent => {
    if (!inbox || !inbox.fromIdentity) {
        return {
            status: 'unavailable',
            description: "This location doesn't have a texting number yet, so client texts won't reach this Inbox.",
            muted: true
        };
    }

    return {
        status: 'active',
        description: `Your clients text ${formatPhone(
            inbox.fromIdentity
        )}. Replies from this number land in your Inbox.`,
        footnote: 'Phone number assigned to this location.'
    };
};
